import { connect } from 'react-redux';

import decorate from '../../utils/decorate';

import injectPermissions from '../../utils/permissionsInject';

import { FraudAndCompliance } from './FraudAndCompliance.tsx';

function mapStateToProps(state) {
    let data = state.user.get('data');

    return {
        name: data && data.get('nickName')
    };
}

export default decorate(
    connect(injectPermissions(mapStateToProps)),
    FraudAndCompliance
);
